import { LABEL_QUEST, LABEL_QUEST_IMG } from "../constants.js";
import { createImagePicker } from "../imagePicker.js";

export function structureScale(id) {
  return `
        <div>
            <div class="title-box">
                <div class="title-text"><i class="bi bi-emoji-smile"></i> Frage mit Skala</div>
                <button type="button" class="btn-node-delete" title="Element entfernen" aria-label="Element entfernen"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr>
            <div class="content-box">
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">${LABEL_QUEST}</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-frage>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">${LABEL_QUEST_IMG}</label>
                        <div class="col-12">
                            ${createImagePicker(id, "frageimg", "df-frageimg")}
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-sm btn-primary"
                    data-bs-toggle="collapse" data-bs-target="#node${id}-options">Optionen</button>
                <div id="node${id}-options" class="answers collapse">
                    <div class="row">
                        <div class="form-group">
                            <label class="col-12">Typ</label>
                            <div class="col-12">
                                <select class="form-select form-select-sm scale-type" df-type>
                                    <option value="smiley3">3 Smileys</option>
                                    <option value="smiley5">5 Smileys</option>
                                    <option value="smiley">Smileys (einfach)</option>
                                    <option value="heart">Herzen</option>
                                    <option value="star" selected>Sterne</option>
                                    <option value="number">Nummern</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row hidden-row">
                        <div class="form-group">
                            <label class="col-12">Anzahl</label>
                            <div class="col-12">
                                <input type="number" class="form-control form-control-sm" min="3" max="10" value="3" df-count>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
}
